import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { captureTicketScreenshot } from "../../../shared/utils/captureTicketScreenshot";
import { useTicketDraftStore } from "../store/ticketDraftStore";

/**
 * ADR-110: rendered once in the main app Layout, visible on every page.
 * Clicking it captures the current screen (auto-masked), queues it as a
 * draft attachment, and navigates the user to the ticket page.
 */
export const TicketCaptureButton: React.FC = () => {
  const navigate = useNavigate();
  const addAttachment = useTicketDraftStore((s) => s.addAttachment);
  const [isCapturing, setIsCapturing] = useState(false);

  const handleClick = useCallback(async () => {
    setIsCapturing(true);
    try {
      const blob = await captureTicketScreenshot();
      addAttachment({
        id: crypto.randomUUID(),
        blob,
        filename: `screenshot-${Date.now()}.png`,
        captureMethod: "direct",
      });
      navigate("/support/tickets/new");
    } finally {
      setIsCapturing(false);
    }
  }, [addAttachment, navigate]);

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isCapturing}
      title="گزارش باگ / پشتیبانی (با عکس)"
      style={{
        background: "transparent",
        border: "none",
        color: isCapturing ? "var(--color-text-muted)" : "var(--color-text-main)",
        borderRadius: "8px",
        width: "32px",
        height: "32px",
        cursor: isCapturing ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.1rem",
        transition: "all 0.2s",
        opacity: isCapturing ? 0.5 : 0.8,
      }}
      onMouseEnter={(e) => {
        if (!isCapturing) {
          e.currentTarget.style.background = "var(--color-surface)";
          e.currentTarget.style.opacity = "1";
        }
      }}
      onMouseLeave={(e) => {
        if (!isCapturing) {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.opacity = "0.8";
        }
      }}
      aria-label="ثبت تیکت با عکس از صفحه"
      data-testid="ticket-capture-button"
    >
      {isCapturing ? "⏳" : "📸"}
    </button>
  );
};

export default TicketCaptureButton;
